import React, {Component} from 'react';
import Loading from "../Common/Loading";
import API from "../../services/API";
import {toast} from "react-toastify";
import Toast from "../Common/Toast";
import NavBar from "../Common/NavBar";
import TopMenu from "../Common/TopMenu";

import {faPlusSquare, faMapMarkerAlt, faStar} from "@fortawesome/free-solid-svg-icons";
import { DatePicker } from "react-persian-datepicker";
import moment from "moment-jalaali";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar as faSolidStar } from "@fortawesome/free-solid-svg-icons";
import { faStar as faRegularStar } from "@fortawesome/free-regular-svg-icons";




const styles = {
    calendarContainer: 'calendarContainer',
    dayPickerContainer: 'dayPickerContainer',
    monthsList: 'monthsList',
    daysOfWeek: 'daysOfWeek',
    dayWrapper: 'dayWrapper',
    selected: 'selected',
    heading: 'heading',
    prev: 'prev',
    next: 'next',
    title: 'title'
}
let pages = [];
for(let p = 1 ; p < 50 ; p++){
    pages[p] = p;
}
class RequestsList extends Component {
    state = {
        requests : [],
        statuses : [],
        status: 0,
        date_from :moment().subtract(7,'days'),
        date_to: moment(),
        isLoaded:false,
    }
    onStateChange = (event) => {

        this.setState({status : event.target.value});
        const request = {
            status_id: event.target.value,
            date_from: this.state.date_from.format("YYYY-MM-DD 00:00:01"),
            date_to: this.state.date_to.format("YYYY-MM-DD 23:59:59"),
        }
        API.requests(request)
            .then((response) => {

                const requests = response.results.requests;
                this.setState({requests})

            })
            .catch((error) => {
                toast.error(error.response.data.user_message);
            });

    }
    onDateChange = (value , type) => {
        let request = [];
        if(type === 'date_from') {
            this.setState({date_from : value});
            request = {
                status_id: this.state.status,
                date_from: value.format("YYYY-MM-DD 00:00:01"),
                date_to: this.state.date_to.format("YYYY-MM-DD 23:59:59"),
            }

        }
        else {
            this.setState({date_to : value})
            request = {
                status_id: this.state.status,
                date_from: this.state.date_from.format("YYYY-MM-DD 00:00:01"),
                date_to: value.format("YYYY-MM-DD 23:59:59"),
            }

        }


        API.requests(request)
            .then((response) => {

                const requests = response.results.requests;
                this.setState({requests})

            })
            .catch((error) => {
                toast.error(error.response.data.user_message);
            });

    }
    render() {

        return (
            <React.Fragment>

                <Toast/>
                <section className="container-fluid rtl ">
                    <div className="row">
                        <div className="col-md-3 px-2">
                            <NavBar/>
                        </div>
                        <div className="col-md-9">
                            <TopMenu/>

                            <div className="text-center my-5 text-secondary">
                                <h2>
                                    <strong>مدیریت درخواست ها</strong>
                                </h2>

                            </div>
                            <section className="container rtl  p-3  ">
                                <div className="row">
                                    <div className="col-12 text-left">
                                        <button className="btn btn-success "
                                                onClick={() => this.props.history.push('/request/new')}>
                                            <FontAwesomeIcon icon={faPlusSquare}/>
                                            &nbsp;
                                            ثبت درخواست جدید
                                        </button>
                                    </div>

                                </div>
                            </section>
                            <section className="container  rtl   px-4 usual-content py-2 ">
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="form-group ">
                                            <select className="form-select w-100 super-small border-0" id="statuses" name="statuses"
                                                    aria-label=" label select example"
                                                    value={this.state.status}
                                                    onChange={this.onStateChange}>
                                                <option value={0}>
                                                    فیلتر بر اساس وضعیت
                                                </option>
                                                {this.state.statuses.map(st => {
                                                    return (
                                                        <option value={st.id} key={st.id} style={{color:st.color}}>
                                                            {st.title}
                                                        </option>
                                                    )
                                                })}
                                            </select>

                                        </div>

                                    </div>
                                    <div className="col-md-2 super-small pt-2 custom-border-right ">
                                        فیلتر بر اساس بازه زمانی :
                                    </div>
                                    <div className="col-md-3 form-group pick-date super-small text-left">
                                        <span>
                                            از
                                        </span>
                                        <DatePicker
                                            calendarStyles={styles}
                                            inputFormat="jYYYY/jM/jD"
                                            className="form-control pdate-picker w-50 d-inline"
                                            value={this.state.date_from}
                                            onChange={(value) => this.onDateChange(value , 'date_from')}
                                        />
                                    </div>
                                    <div className="col-md-3 form-group pick-date super-small text-left">
                                        <span>
                                            تا
                                        </span>
                                        <DatePicker
                                            calendarStyles={styles}
                                            inputFormat="jYYYY/jM/jD"
                                            className="form-control pdate-picker w-50 d-inline"
                                            value={this.state.date_to}
                                            onChange={(value) => this.onDateChange(value , 'date_to')}
                                        />
                                    </div>
                                </div>
                                <div className="row alert alert-secondary rtl super-small-2 p-0 m-0">

                                    <div className="col-3">
                                        &nbsp;
                                    </div>
                                    <div className="col-9 text-left">
                                        <span className='mx-3'>برو به:</span>
                                        <select onChange={(val) => {window.location.assign("/requests/" + val.target.value)}} className='w-50 text-center bg-primary text-white small rounded' defaultValue={parseInt(this.props.match.params.page)}>
                                            {
                                                pages.map (p => {
                                                    return (
                                                        <option value={p}
                                                        >
                                                            صفحه
                                                            &nbsp;
                                                            {p}
                                                        </option>
                                                    )
                                                })
                                            }
                                        </select>
                                    </div>
                                </div>
                            </section>
                            {!this.state.isLoaded ? <Loading/> :''}
                            {
                                this.state.requests.length === 0  ?
                                    <section className="container pb-1 rtl mt-4  px-4 usual-content  ">
                                        <div className="alert alert-info small text-center">
                                         درخواستی برای نمایش وجود ندارد
                                        </div>
                                    </section>
                                    :

                                    <React.Fragment>
                                        {
                                            this.state.requests.map(request => {
                                                return (
                                                    <section key={request.id} className="container pb-2 rtl mt-4  px-4 usual-content border-top-2 " style={{borderTopColor: request.status.color }}>
                                                        <div className="row small ">
                                                            <div className="col-md-6 px-3 pb-3 custom-border-bottom">
                                                                کد پیگیری درخواست:
                                                                &nbsp;
                                                                <b>
                                                                    {request.tracking_code}
                                                                </b>
                                                                {request.small_cargo ?
                                                                    <div className='badge badge-info badge-pill bg-warning  mx-2'>
                                                                        بار خرد
                                                                    </div> : ''
                                                                }
                                                            </div>
                                                            <div className="col-md-6 px-3 pb-3 text-left custom-border-bottom">
                                                                وضعیت درخواست:
                                                                &nbsp;
                                                                <b style={{color: request.status.color}}>
                                                                    {request.status.title}
                                                                </b>
                                                            </div>
                                                        </div>
                                                        <div className="row small ">
                                                            <div className="col-md-6 px-3 py-3 custom-border-bottom">
                                                                خودروی درخواستی:
                                                                &nbsp;
                                                                <b>
                                                                    {request.car_type ? request.car_type.title : ''}
                                                                </b>
                                                            </div>
                                                            <div className="col-md-6 px-3 py-3 text-left custom-border-bottom">
                                                                تاریخ ثبت درخواست:
                                                                &nbsp;
                                                                <b >
                                                                    {request.created_at}
                                                                </b>
                                                            </div>
                                                        </div>
                                                        <div className="row small ">
                                                            <div className="col-md-3 px-3 py-3 custom-border-bottom">
                                                                آدرس های بارگیری:
                                                            </div>
                                                            <div className="col-md-9 px-3 py-3 custom-border-bottom">
                                                                {
                                                                    request.loading_addresses.map(address => {
                                                                        return (
                                                                            <div key={address.id}>
                                                                                <FontAwesomeIcon icon={faMapMarkerAlt}
                                                                                 className='text-secondary mx-3'
                                                                                />
                                                                                    { address.title + ' '}
                                                                                 به آدرس:

                                                                                <b className='px-2'>

                                                                                    {address.address}
                                                                                </b>
                                                                            </div>
                                                                        )
                                                                    })
                                                                }
                                                            </div>
                                                            <div className="col-md-3 px-3 py-3 custom-border-bottom">
                                                                آدرس های تخلیه:

                                                            </div>
                                                            <div className="col-md-9 px-3 py-3 custom-border-bottom">
                                                                {
                                                                    request.unloading_addresses.map(address => {
                                                                        return (
                                                                            <div key={address.id}>
                                                                                <FontAwesomeIcon icon={faMapMarkerAlt}
                                                                                                 className='text-secondary mx-3'
                                                                                />
                                                                                {address.title + ' '}
                                                                                به آدرس:

                                                                                <b className='px-2'>

                                                                                    {address.address}
                                                                                </b>
                                                                            </div>
                                                                        )
                                                                    })
                                                                }
                                                            </div>
                                                        </div>
                                                        {
                                                            request.expert_description?.length > 1 &&
                                                        <div className="row">
                                                            <div className="col-12 px-3 py-3 custom-border-bottom text-danger">
                                                                توضیحات کارشناس:
                                                                {
                                                                    request.expert_description
                                                                }
                                                            </div>
                                                        </div>
                                                        }
                                                        {
                                                            request.backup_driver.length !== 0 ?
                                                                <div className="row small ">
                                                                    <div className="col-md-6 px-3 py-3 custom-border-bottom">
                                                                        نام راننده:
                                                                        &nbsp;
                                                                        <b>
                                                                            {request.backup_driver.first_name} {request.backup_driver.last_name}
                                                                        </b>
                                                                    </div>
                                                                    <div className="col-md-6 px-3 py-3 text-left custom-border-bottom">
                                                                        شماره تماس راننده:
                                                                        &nbsp;
                                                                        <a href={"tel:" + request.driver.mobile} >
                                                                            {request.driver.mobile}
                                                                        </a>
                                                                    </div>

                                                                </div>
                                                                :
                                                                request.driver.length !== 0 ?
                                                                    <div className="row small ">
                                                                        <div className="col-md-6 px-3 py-3 custom-border-bottom">
                                                                            نام راننده:
                                                                            &nbsp;
                                                                            <b>
                                                                                {request.driver.first_name} {request.driver.last_name}
                                                                            </b>
                                                                        </div>
                                                                        <div className="col-md-6 px-3 py-3 text-left custom-border-bottom">
                                                                            شماره تماس راننده:
                                                                            &nbsp;
                                                                            <a href={"tel:" + request.driver.mobile} >
                                                                                {request.driver.mobile}
                                                                            </a>
                                                                        </div>

                                                                    </div> :
                                                                ''
                                                        }
                                                        <div className="row">
                                                            <div className="col-md-6 text-end py-2">
                                                                {[7, 9, 10].includes(request.status.id) && request.rate === 0 &&
                                                                    <button className='btn btn-warning '

                                                                            onClick={() => this.props.history.push('/rate/' + request.id)}>

                                                                        <FontAwesomeIcon icon={faStar} className='mx-2' />

                                                                        ثبت نظر
                                                                    </button>
                                                                }
                                                                {request.rate > 0 && (
                                                                    <div title={request.comment}>
                                                                        {[1, 2, 3, 4, 5].map((star) => (
                                                                            <FontAwesomeIcon
                                                                                key={star}
                                                                                icon={star <= request.rate ? faSolidStar : faRegularStar}
                                                                                style={{ color: "#ffc107", fontSize: 24, marginLeft: 2 }}
                                                                            />
                                                                        ))}
                                                                        <span className="mx-2">({request.rate})</span>
                                                                    </div>
                                                                )}
                                                            </div>
                                                            <div className="col-md-6 text-start px-3 py-2">
                                                                <button className="btn btn-outline-primary p-2 "
                                                                        onClick={() => this.props.history.push('/request-profile/' + request.id)}>
                                                                    <FontAwesomeIcon icon={faPlusSquare}/>
                                                                    &nbsp;
                                                                    مشاهده اطلاعات کامل درخواست
                                                                </button>
                                                            </div>
                                                        </div>

                                                    </section>
                                                )
                                            })
                                        }

                                    </React.Fragment>
                            }
                        </div>

                    </div>

                </section>

            </React.Fragment>


        );
    }
    componentDidMount = () => {
        const request = {
            page: this.props.match.params.page
        }


        API.requests(request)
            .then((response) => {
                const requests = response.results.requests;
                this.setState({requests})
                this.setState({ isLoaded : true})
            })
            .catch((error) => {
                toast.error(error.response.data.user_message);
            });
        API.getStatuses()
            .then((response) => {
                const statuses = response.results.statuses;
                this.setState({statuses})

            })
            .catch((error) => {
                toast.error(error.response.data.user_message);
            });

        setInterval (() => {
            const request = {
                page: this.props.match.params.page
            }
            API.requests(request)
                .then((response) => {
                    const requests = response.results.requests;
                    this.setState({requests})

                })
                .catch((error) => {
                    toast.error(error.response.data.user_message);
                });
        },300000)
    }
}

export default RequestsList;